exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2SmDbz1bYpPjKK{padding-bottom:14px}._2E45Q3mVoVCovz{display:flex;flex-direction:row;justify-content:left;align-items:center}.ZSwDN9di12NohH{margin:4px 4px 4px -14px}._1risZdUbJQfS_F{margin-top:22px;color:#172b4d;font-size:16px;font-weight:600;letter-spacing:-.006em;line-height:20px;margin-top:24px}.iQOLA6D7DZWoTo{color:#172b4d;font-size:14px;font-weight:400;line-height:20px}._3MEF2BLND8pw99{margin-top:16px;margin-bottom:22px}._3MEF2BLND8pw99 a{color:#fff;font-weight:500}", ""]);

// exports
exports.locals = {
	"largeTeamBoardsBannerPadding": "_2SmDbz1bYpPjKK",
	"largeTeamBoardsBanner": "_2E45Q3mVoVCovz",
	"teamBoardsBannerImage": "ZSwDN9di12NohH",
	"teamBoardsBannerHeader": "_1risZdUbJQfS_F",
	"teamBoardsBannerParagraph": "iQOLA6D7DZWoTo",
	"teamBoardsButton": "_3MEF2BLND8pw99"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/member/team-boards-cta/large-team-boards-cta-banner.less
// module id = hRMW
// module chunks = 24